import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../constants/config.js';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [ isLoggedIn, setIsLoggedIn ] = useState( false );
    const [ loading, setLoading ] = useState( true );
    const [ userInfo , setUserInfo ] = useState( {} );

    useEffect( () => {
        async function checkLoginStatus( ) {
            setLoading( true );
            let loggedIn = false;
            let userInfo = {};

            try {
                const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/users/authorized`;
                const requestSettings = {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                const response = await fetch( url , requestSettings );
                const data = await response.json();

                loggedIn = data.isAuthenticated;
                userInfo = data.user;
            } catch ( error ) {
                console.log( error );
            } finally {
                setIsLoggedIn( loggedIn );
                setUserInfo({...userInfo});

                if ( !loggedIn ) {
                    login();
                    setLoading( true );
                } else {
                    setLoading( false );
                }
            }   
        }
        
        checkLoginStatus();
    }, []);

    function login() {
        window.location.href = config.app.LOGIN_REDIRECT_URL;
    }

    function logout() {
        window.location.href = config.app.LOGOUT_REDIRECT_URL;
    }

    return (
        <AuthContext.Provider value={{ isLoggedIn, userInfo, loading, login, logout}}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth( ) {
    return useContext( AuthContext );
}